import React, { useMemo } from 'react';

// Configurazione progressione - sfide necessarie per ogni livello
const LEVELS = [
  { min: 0, max: 4, image: '/reef/level_0.png', label: 'Fondale desolato' },
  { min: 5, max: 9, image: '/reef/level_1.png', label: 'Primi coralli' },
  { min: 10, max: 14, image: '/reef/level_2.png', label: 'Coralli e anemoni' },
  { min: 15, max: 19, image: '/reef/level_3.png', label: 'Pesci colorati' },
  { min: 20, max: 24, image: '/reef/level_4.png', label: 'Tartaruga marina' },
  { min: 25, max: Infinity, image: '/reef/level_5.png', label: 'Barriera completa' }
];

// Componente principale
const CoralReefGame = ({ completedChallenges = 0, daysSinceLastChallenge = 0 }) => {
  
  // Determina il livello corrente
  const currentLevel = useMemo(() => {
    // Se non ha giocato per troppo tempo, torna indietro
    let effectiveChallenges = completedChallenges;
    
    if (daysSinceLastChallenge >= 7) {
      effectiveChallenges = Math.max(0, completedChallenges - 15); // Torna molto indietro
    } else if (daysSinceLastChallenge >= 5) {
      effectiveChallenges = Math.max(0, completedChallenges - 10);
    } else if (daysSinceLastChallenge >= 3) {
      effectiveChallenges = Math.max(0, completedChallenges - 5);
    }
    
    const level = LEVELS.find(l => effectiveChallenges >= l.min && effectiveChallenges <= l.max);
    return level || LEVELS[0];
  }, [completedChallenges, daysSinceLastChallenge]);

  // Calcola prossimo traguardo
  const nextMilestone = useMemo(() => {
    const currentIndex = LEVELS.findIndex(l => l.image === currentLevel.image);
    if (currentIndex < LEVELS.length - 1) {
      const next = LEVELS[currentIndex + 1];
      return {
        label: next.label,
        remaining: next.min - completedChallenges
      };
    }
    return null;
  }, [currentLevel, completedChallenges]);

  // Stato della barriera
  const isInDanger = daysSinceLastChallenge >= 3;

  return (
    <div className="relative w-full rounded-2xl overflow-hidden shadow-2xl" style={{ aspectRatio: '16/10' }}>
      {/* Immagine della barriera */}
      <img 
        src={currentLevel.image}
        alt={currentLevel.label}
        className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
      />
      
      {/* Overlay sfumato per il testo */}
      <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/70 via-black/30 to-transparent">
        <div className="flex items-center justify-between text-white text-sm">
          <div className="flex items-center gap-2">
            <span className="font-medium">{currentLevel.label}</span>
            {isInDanger && (
              <span className="text-yellow-400 animate-pulse text-xs">⚠️ In pericolo!</span>
            )}
          </div>
          {nextMilestone && nextMilestone.remaining > 0 && (
            <div className="text-cyan-300 text-xs">
              Prossimo: {nextMilestone.label} ({nextMilestone.remaining} sfide)
            </div>
          )}
        </div>
      </div>
      
      {/* Warning se la barriera sta morendo */}
      {daysSinceLastChallenge >= 3 && (
        <div className="absolute top-3 left-3 right-3 bg-red-500/90 text-white text-xs p-2 rounded-lg animate-pulse">
          🪸 La tua barriera sta soffrendo! Completa una sfida per salvarla.
        </div>
      )}
      
      {/* Pulsante info (?) */}
      <button 
        className="absolute top-3 right-3 w-8 h-8 bg-black/40 hover:bg-black/60 rounded-full flex items-center justify-center text-white/70 hover:text-white transition-all"
        title="Come funziona"
      >
        ?
      </button>
    </div>
  );
};

export default CoralReefGame;
